<template>
  <div>
    <div class="card-body">
      <hire-vehicle-agreement-form
        :incident="incident"
        :hire="hire"
        :form="form"
        v-if="!hire.hire_agreement"
      ></hire-vehicle-agreement-form>

      <div class="text-center" v-else>
        <button class="btn btn-primary" type="button" @click="download">
          Download Hire Agreement
        </button>

        <div
          class="gutter-top"
          v-if="hasPermission('hires.regenerateDocuments')"
        >
          <p>
            To regenerate the hire agreement
            <a class="cursor-pointer" @click="clearHireAgreement"
              >click here.</a
            >
          </p>
        </div>
      </div>
    </div>

    <div class="card-footer text-right" v-if="!hire.hire_agreement">
      <form-button :indicator="form.processing()" v-on:clicked="generate">
        Generate
      </form-button>
    </div>
  </div>
</template>
<script>
import HireVehicleAgreementForm from './Children/HireVehicleAgreementForm';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    hire: {
      type: Object,
      required: true
    }
  },

  components: {
    HireVehicleAgreementForm
  },

  data() {
    return {
      form: new window.Form({
        excess: null,
        other_excess: null,
        placeholders: []
      })
    };
  },

  methods: {
    generate() {
      this.form
        .post(`/hires/${this.hire.identifier}/hire-agreement`)
        .then(response => {
          this.hire.hire_agreement = response;

          window.toastify.success(
            'Saved',
            "We've successfully generated the hire agreement"
          );

          this.form.reset();
        })
        .catch(err => {
          this.indicator = false;
          window.toastify.error(
            'Error',
            "Sorry, we couldn't generate the document. Please try again"
          );
        });
    },

    download() {
      window.open(this.hire?.hire_agreement?.url, '_blank');
    },

    clearHireAgreement() {
      this.hire.hire_agreement = null;
    }
  }
};
</script>
